import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { rootRoute } from './root.tsx'

// The club's dashboard: the page `/` routes a `club` role to.
export const myOfficialRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialDashboard,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/official/dashboard.tsx')),
})

/** The link other pages take the path from, instead of respelling it. */
export const officialDashboardLink = { to: NAV_PATHS.officialDashboard } as const
